export enum CustomerExperienceLinkType {
    CUSTOMER = '330388fd-b5c6-45e1-89ab-5a2605019140',
    CONTACT = '764c4e62-78c7-4f74-837c-cece57821ff4',
    OPPORTUNITY = 'd9e7e84e-0563-4807-bbd7-35971dbfe000',
    ACTIVITY = 'b3e0c04d-a573-4c24-80b9-6224af055141',
    CARD = 'de84b834-7bfa-4602-8898-38617f4e9b4c',
    ASSIGNMENT = '0cbe42fb-e8cc-4afe-9af2-9909c0efcc7d',
    LEAD_DRAFT = 'b108e575-082d-484c-94d3-f0905d50f40a',
}
